const ShipmentPlanners = () => import("Modules/shipment_planners/views/ShipmentPlanners");
const ShipmentPlannersForm = () => import("Modules/shipment_planners/views/ShipmentPlannersForm");
const ShipmentPlannerFinalize = () => import("Modules/shipment_planners/views/ShipmentPlannerFinalize");
const ShipmentPlannerSign = () => import("Modules/shipment_planners/views/ShipmentPlannerSignature");

export default {
    children: [
        {
            path: "shipment_planners",
            name: "shipment_planners",
            component: ShipmentPlanners,
            meta: {
                requiresAuth: true,
                title: "lang.shipment_planners",
                restrict_by_login_type: [
                    "employee",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_support",
                    "administrator",
                    "developer",
                    "customer",
                    "customer_readonly",
                ],
                restrict_by_permission: ["shipment_planners.read"],
            },
        },
        {
            path: "shipment_planners/:id?",
            name: "shipment_planner",
            component: ShipmentPlannersForm,
            meta: {
                requiresAuth: true,
                title: "lang.shipment_planners",
                restrict_by_login_type: [
                    "employee",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_support",
                    "administrator",
                    "developer",
                    "customer",
                    "customer_readonly",
                ],
                restrict_by_permission: ["shipment_planners.read"],
            },
        },
        {
            path: "shipment_planners/:id?/finalize",
            name: "shipment_planner_finalize",
            component: ShipmentPlannerFinalize,
            meta: {
                requiresAuth: true,
                title: "lang.finalize_shipment",
                restrict_by_login_type: [
                    "employee",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_support",
                    "administrator",
                    "developer",
                    "customer",
                    "customer_readonly",
                ],
                restrict_by_permission: ["shipment_planners.update"],
            },
        },
        {
            path: "shipment_planners/:id?/sign",
            name: "shipment_planner_sign",
            component: ShipmentPlannerSign,
            meta: {
                requiresAuth: true,
                title: "lang.shipment",
                restrict_by_login_type: [
                    "employee",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_support",
                    "administrator",
                    "developer",
                    "customer",
                    "customer_readonly",
                ],
                restrict_by_permission: ["shipment_planners.update"],
            },
        },
    ],
};
